import { render, staticRenderFns } from "./glkh.vue?vue&type=template&id=00d66cb8&scoped=true&"
import script from "./glkh.vue?vue&type=script&lang=js&"
export * from "./glkh.vue?vue&type=script&lang=js&"
import style0 from "./glkh.vue?vue&type=style&index=0&id=00d66cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d66cb8",
  null
  
)

export default component.exports